import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ChatIconButton from '$app-web/ui-kit/components/chat-icon-button';
import LoadingIndicatorBar from '$app-web/ui-kit/components/loading-indicator-bar';
import TextField from '$app-web/ui-kit/components/text-field';

import {
    useIsRoomsSearchRemote,
    useIsSearchingRemoteRooms,
    useMethods,
    useRoomsSearchKeyword,
} from '../../state/chat-client.state';
import classes from './styles.module.scss';

const SearchBar = (props) => {
    const { onChangeShouldShowArchiveds, showArchiveds } = props;

    const { t } = useTranslation();

    const methods = useMethods();
    const roomsSearchKeyword = useRoomsSearchKeyword();
    const isRoomsSearchRemote = useIsRoomsSearchRemote();
    const isSearchingRemoteRooms = useIsSearchingRemoteRooms();

    return (
        <>
            <div className={clsx('flex items-center space-1', classes.actions)}>
                {/* TODO-MAYBE: Add a badge if there are unread events on any archived room. */}
                <ChatIconButton
                    icon={['fas', showArchiveds || isRoomsSearchRemote ? 'arrow-left' : 'archive']}
                    className="item"
                    onClick={() => {
                        if (!isRoomsSearchRemote) {
                            onChangeShouldShowArchiveds(!showArchiveds);
                        } else {
                            methods.setRoomsSearchKeyword('');
                            methods.setIsRoomsSearchRemote(false);
                        }
                    }}
                />
                <div className="item xs">
                    <TextField
                        value={roomsSearchKeyword}
                        onChange={methods.setRoomsSearchKeyword}
                        placeholder={t('search')}
                        fullWidth
                    />
                </div>
            </div>
            <div className={classes.loadingWrapper}>
                {isSearchingRemoteRooms && isRoomsSearchRemote && <LoadingIndicatorBar />}
            </div>
        </>
    );
};

SearchBar.propTypes = {
    onChangeShouldShowArchiveds: PropTypes.func.isRequired,
    showArchiveds: PropTypes.bool.isRequired,
};

export default SearchBar;
